import { ArrowLeft, FileText } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import { useNavigate } from "react-router-dom";
import welcomeBg from "../../assets/homebg.png";

const LicensesPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="scrollbar-hide relative mx-auto w-full max-w-[400px] bg-background"
      style={{
        minHeight: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Blurred Background Image */}
      <div
        className="absolute inset-0 scale-105 bg-cover bg-center bg-no-repeat blur-md"
        style={{
          backgroundImage: `url(${welcomeBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-background/80" />

      <div
        className="scrollbar-hide relative z-10 space-y-5 overflow-y-auto p-4 pb-20"
        style={{ height: "calc(100vh - 0px)" }}
      >
        {/* Header */}
        <div className="flex items-center gap-4 pt-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            className="rounded-xl bg-card/80 shadow-md hover:bg-card"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold text-foreground">Licenses</h1>
        </div>

        {/* Content Card */}
        <Card className="space-y-5 rounded-2xl border border-border bg-card p-6 shadow-lg">
          {/* Icon Header */}
          <div className="flex items-start gap-4">
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-blue-50">
              <FileText className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <h3 className="font-bold text-foreground">
                Open Source Licenses
              </h3>
              <p className="text-xs text-muted-foreground">
                Software acknowledgments
              </p>
            </div>
          </div>

          {/* Description */}
          <p className="text-sm leading-relaxed text-blue-600">
            Bite Balance is built using various open-source software components.
            We are grateful to the open-source community for their contributions
            that help make this app possible.
          </p>

          <p className="text-sm leading-relaxed text-blue-600">
            All third-party software used in this application is licensed under
            their respective open-source licenses, including MIT, Apache 2.0,
            and ISC licenses.
          </p>

          {/* Contact */}
          <p className="text-sm text-muted-foreground">
            For detailed license information, please contact us at{" "}
            <span className="text-blue-600">legal@bitebalance.com</span>
          </p>
        </Card>

        {/* Footer */}
        <p className="text-center text-xs text-muted-foreground/70">
          © 2026 Bite Balance. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default LicensesPage;
